// extracted by mini-css-extract-plugin
export default {"container":"product-thumbnail_container__u6XKI"};